import React from 'react';
import './css/maintenancePage.css';

const MaintenancePage: React.FC = () => {
  return (
    <div className="maintenance_page">
      <div className="maintenance_container">
        <div className="maintenance_logo">
          <img src="/images/wfc/wfc/unnamed-removebg-preview.png" alt="WFC Nike Lusso" />
        </div>
        <h1 className="maintenance_title">Site Under Maintenance</h1>
        <p className="maintenance_message">
          Sorry, our website is currently being updated.
        </p>
        <p className="maintenance_submessage">
          Please come back later.
        </p>
        <div className="maintenance_icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#0b5330" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 17L12 22L22 17" stroke="#0b5330" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 12L12 17L22 12" stroke="#0b5330" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
